var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5H19.3333H30",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4166 20.4987C29.4166 20.0845 29.0808 19.7487 28.6666 19.7487C28.2524 19.7487 27.9166 20.0845 27.9166 20.4987H29.4166ZM20.0833 20.4987C20.0833 20.0845 19.7475 19.7487 19.3333 19.7487C18.919 19.7487 18.5833 20.0845 18.5833 20.4987H20.0833ZM20.5833 20.4987C20.5833 20.9129 20.919 21.2487 21.3333 21.2487C21.7475 21.2487 22.0833 20.9129 22.0833 20.4987H20.5833ZM25.9166 20.4987C25.9166 20.9129 26.2524 21.2487 26.6666 21.2487C27.0808 21.2487 27.4166 20.9129 27.4166 20.4987H25.9166ZM27.9166 20.4987V29.832H29.4166V20.4987H27.9166ZM27.9166 29.832C27.9166 30.1542 27.6554 30.4154 27.3333 30.4154V31.9154C28.4838 31.9154 29.4166 30.9826 29.4166 29.832H27.9166ZM27.3333 30.4154H20.6666V31.9154H27.3333V30.4154ZM20.6666 30.4154C20.3444 30.4154 20.0833 30.1542 20.0833 29.832H18.5833C18.5833 30.9826 19.516 31.9154 20.6666 31.9154V30.4154ZM20.0833 29.832V20.4987H18.5833V29.832H20.0833ZM22.0833 20.4987V19.1654H20.5833V20.4987H22.0833ZM22.0833 19.1654C22.0833 18.8432 22.3444 18.582 22.6666 18.582V17.082C21.516 17.082 20.5833 18.0148 20.5833 19.1654H22.0833ZM22.6666 18.582H25.3333V17.082H22.6666V18.582ZM25.3333 18.582C25.6554 18.582 25.9166 18.8432 25.9166 19.1654H27.4166C27.4166 18.0148 26.4838 17.082 25.3333 17.082V18.582ZM25.9166 19.1654V20.4987H27.4166V19.1654H25.9166Z",
    fill: "#7B8794"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 23.832V27.832",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 23.832V27.832",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 47.5,
    height: 47.5,
    rx: 23.75,
    stroke: "#323F4B",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f3405f70f11d919b56e6f432e8b19b0b.svg";
export { ForwardRef as ReactComponent };